import React, { useContext } from 'react'
import { Row, Col, Collapse } from 'react-bootstrap'
import { firebaseAuth } from '../../../services/firebase'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { MigrantContext } from '../../../contexts/migrantContext'
import { getProfile } from '../../../services/migrantService'
import { toast } from 'react-toastify'
import PhoneLoginSignupForm, {
  PhoneLoginSignupFormMode
} from './phoneLoginSignupForm'

type PhoneLoginProps = {
  expanded: boolean
  onClick: () => void
  uiConfig: firebaseui.auth.Config
  styles: {
    readonly [key: string]: string
  }
}

function PhoneLogin({ expanded, onClick, uiConfig, styles }: PhoneLoginProps) {
  const migrantContext = useContext(MigrantContext)

  const handlePhoneLogin = async (userId: string) => {
    try {
      const profile = await getProfile(userId)
      if (!profile) {
        throw new Error('Internal error')
      }

      migrantContext?.setProfile(profile)
    } catch (err) {
      firebaseAuth().signOut()
      const message = friendlyMessageFor(err)
      toast.error(message, { autoClose: false })
    }
  }

  return (
    <div className={styles.loginForm}>
      <Row>
        <Col onClick={onClick}>
          <b>Sign In</b>
          {/* <div
            className={
              styles.expandButton +
              (expanded ? ` ${styles.expandButtonActive}` : '')
            }
          /> */}
        </Col>
      </Row>
      <Collapse in={expanded} data-testid="onboarding-signin">
        <div>
          <PhoneLoginSignupForm
            mode={PhoneLoginSignupFormMode.login}
            phoneLoginCallback={handlePhoneLogin}
            uiConfig={expanded ? uiConfig : undefined}
          />
        </div>
      </Collapse>
    </div>
  )
}

export default PhoneLogin
